<template>
  <div class="app-options-details-list-item">
    <b-row class="table-header-row" v-if="showHeader">
      <b-col class="table-box left-box">
        <slot name="lblProduct" v-if="!isService">Produkt</slot>
        <slot name="lblService" v-if="isService">Service</slot>
      </b-col>
      <b-col class="table-box right-box">
        <slot name="lblDurationMonth" v-if="showPeriodic">Regelmäßig</slot>
        <slot name="lblDurationOnce" v-if="showUnique">Einmalig</slot>
        <slot name="lblDurationUnlimited" v-if="showUnlimited">Gültig bis: unbefristet</slot>
      </b-col>
    </b-row>
    <b-row class="table-content-row">
      <b-col class="left-box table-box">
        <b-row>
          <b-col class="item-name">
            <span>{{ item.name }}</span>
          </b-col>
          <b-col class="includes-list">
            <div v-html="item.descriptionOrdering"></div>
          </b-col>
          <b-col class="contract" v-if="contractUrl && (item.tariffId || item.automaticExtension === true) && showSummaryText === true">
            Die Vertragszusammenfassung finden Sie <a @click="download()" target="_blank" class="summary-link">
            <slot name="txtDocument">hier</slot></a>.
          </b-col>
          <b-col class="item-extra-info">
            <p class="item-extra-info-label">
              <a @click="visible = !visible">
                <slot name="txtToggleOpen" v-if="visible">- zusätzliche Infos ausblenden</slot>
                <slot name="txtToggleClosed" v-if="!visible">- zusätzliche Infos einblenden</slot>
              </a>
            </p>
            <b-collapse id="collapseInfo" v-model="visible">
              <b-card>
                <div v-html="this.item.extraInfoOrdering"></div>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="right-box table-box">
        <div class="price-label">
          <slot name="lblDuration">{{ priceDuration }}</slot>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import FileSaver from 'file-saver'

export default {
  name: 'OptionsDetailsListItem',
  data () {
    return {
      visible: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showSummaryText: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    download: function () {
      const me = this
      axios.get(this.contractUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    ...mapGetters('bookTariffOptions', [
      'bookTariffoptionDocumentUrl'
    ]),
    ...mapGetters('tariffs', [
      'getContractUrl'
    ]),
    ...mapGetters('activation/submit', [
      'contractDocumentUrl'
    ]),
    contractUrl: function () {
      if (this.getContractUrl !== null) {
        return this.getContractUrl
      } else if (this.contractDocumentUrl !== null) {
        return this.contractDocumentUrl
      } else if (this.bookTariffoptionDocumentUrl !== null) {
        return this.bookTariffoptionDocumentUrl
      } else {
        return null
      }
    },
    priceDuration: function () {
      const format = (formattedPrice, runtime) => {
        let amount = runtime.amount
        if (amount === 1) {
          amount = ''
        } else {
          amount += ' '
        }
        return formattedPrice + ' / ' + amount + runtime.formattedUnit
      }
      // handles runtime-duration problem without property-solution
      if (this.item.tariffoptionId) {
        return format(this.item.formattedPrice, this.item.duration)
      } else if (this.item.tariffId) {
        return format(this.item.formattedBasicFee, this.item.runtime)
      } else if (this.isService) {
        return 'kostenlos'
      }
      return 'keine'
    },
    isService: function () {
      return this.item.serviceOptionId === 'acr'
    },
    showPeriodic: function () {
      return (this.item.tariffId !== undefined || this.item.automaticExtension === true)
    },
    showUnique: function () {
      return (this.item.tariffOptionId !== undefined && this.item.automaticExtension === false)
    },
    showUnlimited: function () {
      return this.isService
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
